<template>
  <div class="etiquetas-page">
    <div class="dashboard-header mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="dashboard-header-titulo-row">
          <h2 class="dashboard-title">
            <feather-icon
              icon="TagIcon"
              size="32"
              class="titulo-icon-left"
            />
            <span class="titulo-texto">Etiquetas</span>
            <router-link
              :to="{ name: 'dashboard-main' }"
              class="dashboard-header-home"
              title="Ir para o início"
            >
              <feather-icon
                icon="HomeIcon"
                size="16"
                class="dashboard-header-home-icon"
              />
            </router-link>
          </h2>
        </div>
        <p class="text-muted mb-0 w-100 dashboard-header-subtitle">
          Desempenho das etiquetas: conversas, tempo de resposta, resolução e casos resolvidos
        </p>
      </div>
    </div>

    <b-card
      v-if="facebookAccountsLista.length > 1"
      class="mb-4 card-selecao-loja"
    >
      <div class="d-flex flex-wrap align-items-center">
        <feather-icon
          icon="StoreIcon"
          size="18"
          class="mr-2 text-primary"
        />
        <label class="mb-0 mr-3 font-weight-bold">Selecionar Loja:</label>
        <b-form-select
          v-model="chatSelecionado"
          :options="facebookAccountsLista.map(conta => ({
            value: conta.chat_token,
            text: conta.name
          }))"
          class="select-loja"
          @change="carregarDados"
        />
      </div>
    </b-card>

    <b-card class="filtros-card periodo-card mb-4">
      <div
        class="periodo-card-trigger d-flex align-items-center justify-content-between"
        @click="periodoCardAberto = !periodoCardAberto"
      >
        <div class="d-flex align-items-center flex-wrap">
          <feather-icon icon="CalendarIcon" size="20" class="periodo-trigger-icon text-primary mr-2" />
          <span class="periodo-trigger-label">{{ periodoTriggerLabel }}</span>
          <span class="periodo-trigger-range text-muted ml-2">{{ periodoTriggerRange }}</span>
        </div>
        <feather-icon
          :icon="periodoCardAberto ? 'ChevronUpIcon' : 'ChevronDownIcon'"
          size="20"
          class="periodo-trigger-chevron text-muted"
        />
      </div>
      <b-collapse v-model="periodoCardAberto" class="mt-3">
        <div class="periodo-card-body">
          <div class="row">
            <div class="col-12 col-md-4 periodo-presets">
              <h6 class="periodo-presets-title">Intervalo de data</h6>
              <div class="periodo-presets-list">
                <button
                  type="button"
                  class="periodo-preset-btn"
                  :class="{ active: atalhoDias === 7 }"
                  @click.stop="aplicarPeriodo(7)"
                >
                  Últimos 7 dias
                </button>
                <button
                  type="button"
                  class="periodo-preset-btn"
                  :class="{ active: atalhoDias === 15 }"
                  @click.stop="aplicarPeriodo(15)"
                >
                  Últimos 15 dias
                </button>
                <button
                  type="button"
                  class="periodo-preset-btn"
                  :class="{ active: atalhoDias === 31 }"
                  @click.stop="aplicarPeriodo(31)"
                >
                  Últimos 31 dias
                </button>
                <button
                  type="button"
                  class="periodo-preset-btn"
                  :class="{ active: atalhoDias === null }"
                  @click.stop="selecionarPersonalizado"
                >
                  Personalizado
                </button>
              </div>
            </div>
            <div class="col-12 col-md-8">
              <div class="row">
                <div class="col-12 col-sm-6">
                  <label class="periodo-field-label">Data de início</label>
                  <b-form-datepicker
                    v-model="periodoInicio"
                    locale="pt-BR"
                    :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                    class="periodo-datepicker w-100"
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <label class="periodo-field-label">Data final</label>
                  <b-form-datepicker
                    v-model="periodoFim"
                    locale="pt-BR"
                    :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                    class="periodo-datepicker w-100"
                  />
                </div>
              </div>
              <div class="periodo-card-footer d-flex justify-content-end gap-2 mt-3">
                <b-button variant="outline-secondary" size="sm" @click.stop="limparPeriodo">
                  Limpar
                </b-button>
                <b-button
                  variant="primary"
                  size="sm"
                  :disabled="carregando"
                  @click.stop="aplicarPeriodoEBuscar"
                >
                  <b-spinner v-if="carregando" small type="grow" class="mr-1" />
                  Aplicar
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
      <p class="text-muted small mb-0 mt-2">
        Período máximo: 31 dias. Padrão: últimos 7 dias.
      </p>
    </b-card>

    <b-card class="mb-4 filtros-card">
      <div class="d-flex flex-wrap align-items-start">
        <b-form-checkbox
          v-model="considerarHorarioAtendimento"
          class="mr-2"
          switch
          :disabled="!temHorarioConfigurado"
        >
          Considerar somente o horário de atendimento
        </b-form-checkbox>
        <span class="text-muted small">
          <template v-if="temHorarioConfigurado">
            Quando ativo, o Tempo médio da primeira resposta e o Tempo médio de resolução consideram somente minutos dentro do horário de atendimento da loja.
          </template>
          <template v-else>
            Ative apenas quando a loja tiver horário de atendimento configurado.
          </template>
        </span>
      </div>
      <div
        v-if="considerarHorarioAtendimento && textoHorarioConfigurado"
        class="mt-3 pt-3 border-top"
      >
        <strong class="d-block mb-1 small">Horários configurados:</strong>
        <span class="text-muted small">{{ textoHorarioConfigurado }}</span>
      </div>
    </b-card>

    <b-card class="table-card">
      <h5 class="card-title-custom mb-4">
        <feather-icon
          icon="ListIcon"
          size="20"
          class="mr-2"
        />
        Métricas por etiqueta
      </h5>
      <b-table
        :items="tabelaEtiquetasPagina"
        :fields="camposTabela"
        striped
        hover
        responsive
        bordered
        class="tabela-etiquetas tabela-etiquetas-clickable"
        show-empty
        empty-text="Nenhuma etiqueta com dados no período."
        @row-clicked="irParaVisaoEtiqueta"
      >
        <template #cell(nome)="data">
          <b-badge
            v-if="data.item.cor"
            :style="{ backgroundColor: data.item.cor, color: '#fff' }"
            class="badge-etiqueta"
          >
            {{ data.item.nome }}
          </b-badge>
          <span v-else>{{ data.item.nome }}</span>
        </template>
        <template #cell(tempo_primeira_resposta)="data">
          {{ formatarTempoMinutos(data.item.tempo_primeira_resposta) }}
        </template>
        <template #cell(tempo_resolucao)="data">
          {{ formatarTempoMinutos(data.item.tempo_resolucao) }}
        </template>
      </b-table>
      <div
        v-if="tabelaEtiquetas.length > perPageEtiquetas"
        class="d-flex justify-content-between align-items-center flex-wrap mt-2 px-1"
      >
        <span class="text-muted small">
          Mostrando {{ (paginaAtualEtiquetas - 1) * perPageEtiquetas + 1 }} a
          {{ Math.min(paginaAtualEtiquetas * perPageEtiquetas, tabelaEtiquetas.length) }}
          de {{ tabelaEtiquetas.length }} etiquetas
        </span>
        <b-pagination
          v-model="paginaAtualEtiquetas"
          :total-rows="tabelaEtiquetas.length"
          :per-page="perPageEtiquetas"
          size="sm"
          align="right"
          pills
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  buscaTag,
  buscaResolvidos,
  buscaChatsTeste,
} from '../../functions/basics/chat'

/**
 * Tempo em minutos até a primeira resposta (tempo de relógio).
 */
function calcularTempoPrimeiraRespostaMin(at) {
  const primeiraRespostaEm = at.primeira_mensagem_atendente_em ? new Date(at.primeira_mensagem_atendente_em).getTime() : null
  if (primeiraRespostaEm == null || Number.isNaN(primeiraRespostaEm)) return null
  const usoInicio = at.atendimento_bot === false && (at.fim_bot == null || at.fim_bot === undefined)
  const ref = usoInicio
    ? (at.inicio ? new Date(at.inicio).getTime() : null)
    : (at.fim_bot ? new Date(at.fim_bot).getTime() : null)
  if (ref == null || Number.isNaN(ref)) return null
  return (primeiraRespostaEm - ref) / 1000 / 60
}

function refPrimeiraResposta(at) {
  const usoInicio = at.atendimento_bot === false && (at.fim_bot == null || at.fim_bot === undefined)
  if (usoInicio && at.inicio) return new Date(at.inicio).getTime()
  if (at.fim_bot) return new Date(at.fim_bot).getTime()
  return null
}

/**
 * Minutos entre inicio e fim que caem dentro do horario_funcionamento.
 */
function minutosDentroDoHorario(inicioTimestamp, fimTimestamp, horarioFuncionamento) {
  if (!inicioTimestamp || !fimTimestamp || !horarioFuncionamento || !horarioFuncionamento.length) return null
  const inicio = new Date(inicioTimestamp)
  const fim = new Date(fimTimestamp)
  if (Number.isNaN(inicio.getTime()) || Number.isNaN(fim.getTime()) || inicio >= fim) return 0
  let totalMin = 0
  const dayStart = new Date(inicio.getFullYear(), inicio.getMonth(), inicio.getDate(), 0, 0, 0, 0)
  const dayEnd = new Date(fim.getFullYear(), fim.getMonth(), fim.getDate(), 23, 59, 59, 999)
  let d = new Date(dayStart)
  while (d <= dayEnd) {
    const dia = d.getDay()
    const year = d.getFullYear()
    const month = d.getMonth()
    const date = d.getDate()
    const intervalos = horarioFuncionamento.filter(h => h.dia === dia)
    for (let i = 0; i < intervalos.length; i++) {
      const int = intervalos[i]
      const [abreH, abreM] = (int.abre || '00:00').split(':').map(Number)
      const [fechaH, fechaM] = (int.fecha || '23:59').split(':').map(Number)
      const intervalStart = new Date(year, month, date, abreH || 0, abreM || 0, 0, 0)
      const intervalEnd = new Date(year, month, date, fechaH || 23, fechaM || 59, 59, 999)
      const overlapStart = new Date(Math.max(inicio.getTime(), intervalStart.getTime()))
      const overlapEnd = new Date(Math.min(fim.getTime(), intervalEnd.getTime()))
      if (overlapStart < overlapEnd) {
        totalMin += (overlapEnd.getTime() - overlapStart.getTime()) / 60000
      }
    }
    d.setDate(d.getDate() + 1)
  }
  return totalMin
}

export default {
  name: 'Etiquetas',
  data() {
    const fim = new Date()
    const inicio = new Date()
    inicio.setDate(inicio.getDate() - 6)
    return {
      facebookAccountsLista: [],
      chatSelecionado: null,
      carregando: false,
      periodoInicio: inicio,
      periodoFim: fim,
      atalhoDias: 7,
      periodoCardAberto: false,
      considerarHorarioAtendimento: false,
      listaTags: [],
      resolvidos: [],
      paginaAtualEtiquetas: 1,
      perPageEtiquetas: 15,
      camposTabela: [
        { key: 'nome', label: 'Nome da Etiqueta' },
        { key: 'numero_conversas', label: 'Número de Conversas' },
        { key: 'tempo_primeira_resposta', label: 'Tempo Médio da Primeira Resposta' },
        { key: 'tempo_resolucao', label: 'Tempo Médio de Resolução' },
        { key: 'numero_resolucoes', label: 'Número de Resoluções' },
      ],
    }
  },
  computed: {
    periodoTriggerLabel() {
      if (this.atalhoDias === 7) return 'Últimos 7 dias'
      if (this.atalhoDias === 15) return 'Últimos 15 dias'
      if (this.atalhoDias === 31) return 'Últimos 31 dias'
      return 'Período personalizado'
    },
    tabelaEtiquetasPagina() {
      const start = (this.paginaAtualEtiquetas - 1) * this.perPageEtiquetas
      return this.tabelaEtiquetas.slice(start, start + this.perPageEtiquetas)
    },
    periodoTriggerRange() {
      const i = this.periodoInicio ? new Date(this.periodoInicio) : null
      const f = this.periodoFim ? new Date(this.periodoFim) : null
      if (!i || !f) return ''
      const fmt = d => d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short', year: 'numeric' })
      return `${fmt(i)} - ${fmt(f)}`
    },
    horarioSelecionado() {
      const chat = this.facebookAccountsLista.find(c => c.chat_token === this.chatSelecionado)
      return chat?.horario_funcionamento || []
    },
    temHorarioConfigurado() {
      return this.horarioSelecionado.length > 0
    },
    textoHorarioConfigurado() {
      const h = this.horarioSelecionado
      if (!h.length) return ''
      const nomesDia = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
      const porDia = {}
      h.forEach(({ dia, abre, fecha }) => {
        if (!porDia[dia]) porDia[dia] = []
        porDia[dia].push(`${abre || ''}-${fecha || ''}`)
      })
      return Object.keys(porDia)
        .sort((a, b) => Number(a) - Number(b))
        .map(d => `${nomesDia[Number(d)]}: ${porDia[d].join(', ')}`)
        .join(' | ')
    },
    tabelaEtiquetas() {
      const tagNames = new Set()
      const tagCor = {}
      this.listaTags.forEach(t => {
        const nome = (t.nome || t.name || '').toString().trim()
        if (nome) {
          tagNames.add(nome)
          tagCor[nome] = t.cor || t.color || null
        }
      })
      this.resolvidos.forEach(at => {
        (at.tags || []).forEach(t => {
          const nome = typeof t === 'string' ? t.trim() : (t.nome || t.name || '').toString().trim()
          if (nome) tagNames.add(nome)
        })
      })

      const metricasPorTag = {}
      tagNames.forEach(nome => {
        metricasPorTag[nome] = {
          nome,
          cor: tagCor[nome] || this.listaTags.find(t => (t.nome || t.name || '').toString().trim() === nome)?.cor || null,
          numero_conversas: 0,
          soma_primeira_resposta: 0,
          count_primeira_resposta: 0,
          soma_resolucao: 0,
          count_resolucao: 0,
          numero_resolucoes: 0,
        }
      })

      const horario = this.horarioSelecionado
      const considerarHorario = this.considerarHorarioAtendimento && horario.length > 0

      this.resolvidos.forEach(at => {
        const tags = (at.tags || []).map(t => (typeof t === 'string' ? t.trim() : (t.nome || t.name || '').toString().trim())).filter(Boolean)
        const fim = at.fim || at.data_resolucao || at.ultima_mensagem_em
        const inicioAt = at.inicio ? new Date(at.inicio).getTime() : null
        const fimAt = fim ? new Date(fim).getTime() : null
        let tempoResolucaoMin = null
        if (inicioAt && fimAt) {
          tempoResolucaoMin = considerarHorario
            ? minutosDentroDoHorario(inicioAt, fimAt, horario)
            : (fimAt - inicioAt) / 1000 / 60
        }
        let primeiraRespostaMin = null
        if (at.primeira_mensagem_atendente_em) {
          const ref = refPrimeiraResposta(at)
          if (ref != null) {
            primeiraRespostaMin = considerarHorario
              ? minutosDentroDoHorario(ref, new Date(at.primeira_mensagem_atendente_em).getTime(), horario)
              : calcularTempoPrimeiraRespostaMin(at)
          }
        }

        if (tags.length === 0) {
          const nome = 'Sem etiqueta'
          if (!metricasPorTag[nome]) {
            metricasPorTag[nome] = {
              nome,
              cor: null,
              numero_conversas: 0,
              soma_primeira_resposta: 0,
              count_primeira_resposta: 0,
              soma_resolucao: 0,
              count_resolucao: 0,
              numero_resolucoes: 0,
            }
          }
          metricasPorTag[nome].numero_conversas += 1
          if (at.primeira_mensagem_atendente_em) {
            metricasPorTag[nome].count_primeira_resposta += 1
            if (primeiraRespostaMin != null && !Number.isNaN(primeiraRespostaMin)) {
              metricasPorTag[nome].soma_primeira_resposta += primeiraRespostaMin
            }
          }
          if (tempoResolucaoMin != null && !Number.isNaN(tempoResolucaoMin)) {
            metricasPorTag[nome].soma_resolucao += tempoResolucaoMin
            metricasPorTag[nome].count_resolucao += 1
          }
          if (fim) metricasPorTag[nome].numero_resolucoes += 1
          return
        }

        tags.forEach(nome => {
          if (!metricasPorTag[nome]) return
          metricasPorTag[nome].numero_conversas += 1
          if (at.primeira_mensagem_atendente_em) {
            metricasPorTag[nome].count_primeira_resposta += 1
            if (primeiraRespostaMin != null && !Number.isNaN(primeiraRespostaMin)) {
              metricasPorTag[nome].soma_primeira_resposta += primeiraRespostaMin
            }
          }
          if (tempoResolucaoMin != null && !Number.isNaN(tempoResolucaoMin)) {
            metricasPorTag[nome].soma_resolucao += tempoResolucaoMin
            metricasPorTag[nome].count_resolucao += 1
          }
          if (fim) metricasPorTag[nome].numero_resolucoes += 1
        })
      })

      return Object.keys(metricasPorTag).map(nome => {
        const m = metricasPorTag[nome]
        return {
          nome: m.nome,
          cor: m.cor,
          numero_conversas: m.numero_conversas,
          tempo_primeira_resposta: m.count_primeira_resposta
            ? m.soma_primeira_resposta / m.count_primeira_resposta
            : null,
          tempo_resolucao: m.count_resolucao ? m.soma_resolucao / m.count_resolucao : null,
          numero_resolucoes: m.numero_resolucoes,
        }
      }).filter(r => r.nome).sort((a, b) => (b.numero_conversas || 0) - (a.numero_conversas || 0))
    },
  },
  watch: {
    '$route.query'(query) {
      if (query && (query.periodo_inicio || query.periodo_fim || query.uuid || query.considerar_horario !== undefined)) {
        this.aplicarFiltrosDaQuery()
        if (this.chatSelecionado) this.carregarDados()
      }
    },
    periodoInicio() {
      this.atualizarAtalhoDiasPelasDatas()
    },
    periodoFim() {
      this.atualizarAtalhoDiasPelasDatas()
    },
    tabelaEtiquetas() {
      this.paginaAtualEtiquetas = 1
    },
  },
  mounted() {
    this.carregarLojas().then(() => {
      this.aplicarFiltrosDaQuery()
      this.carregarDados()
    })
  },
  methods: {
    aplicarPeriodo(dias) {
      const fim = new Date()
      const inicio = new Date()
      inicio.setDate(fim.getDate() - dias + 1)
      this.periodoInicio = inicio
      this.periodoFim = fim
      this.atalhoDias = dias
    },
    limparPeriodo() {
      this.aplicarPeriodo(7)
    },
    selecionarPersonalizado() {
      this.atalhoDias = null
    },
    atualizarAtalhoDiasPelasDatas() {
      const i = this.periodoInicio ? new Date(this.periodoInicio) : null
      const f = this.periodoFim ? new Date(this.periodoFim) : null
      if (!i || !f || Number.isNaN(i.getTime()) || Number.isNaN(f.getTime())) return
      const diffDias = Math.round((f - i) / (1000 * 60 * 60 * 24)) + 1
      if (diffDias === 7) this.atalhoDias = 7
      else if (diffDias === 15) this.atalhoDias = 15
      else if (diffDias === 31) this.atalhoDias = 31
      else this.atalhoDias = null
    },
    aplicarPeriodoEBuscar() {
      this.periodoCardAberto = false
      this.carregarDados()
    },
    formatarTempoMinutos(valor) {
      if (valor == null || Number.isNaN(valor)) return '—'
      const n = Math.round(valor)
      if (n < 60) return `${n} min`
      const h = Math.floor(n / 60)
      const m = n % 60
      return m ? `${h}h ${m}min` : `${h}h`
    },
    irParaVisaoEtiqueta(item) {
      const nome = (item && item.nome) ? String(item.nome).trim() : ''
      if (!nome) return
      const i = this.periodoInicio ? new Date(this.periodoInicio) : null
      const f = this.periodoFim ? new Date(this.periodoFim) : null
      const fmt = d => d && !Number.isNaN(d.getTime()) ? d.toISOString().slice(0, 10) : null
      const query = {
        etiqueta: nome,
        ...(this.chatSelecionado ? { uuid: this.chatSelecionado } : {}),
        ...(fmt(i) ? { periodo_inicio: fmt(i) } : {}),
        ...(fmt(f) ? { periodo_fim: fmt(f) } : {}),
        considerar_horario: this.considerarHorarioAtendimento ? '1' : '0',
      }
      this.$router.push({ name: 'chat-etiqueta-visao', query })
    },
    aplicarFiltrosDaQuery() {
      const query = this.$route.query
      if (!query) return
      if (query.uuid && this.facebookAccountsLista.some(c => c.chat_token === query.uuid)) {
        this.chatSelecionado = query.uuid
      }
      if (query.periodo_inicio && query.periodo_fim) {
        const i = new Date(query.periodo_inicio)
        const f = new Date(query.periodo_fim)
        if (!Number.isNaN(i.getTime()) && !Number.isNaN(f.getTime())) {
          this.periodoInicio = i
          this.periodoFim = f
          this.atualizarAtalhoDiasPelasDatas()
        }
      }
      if (query.considerar_horario === '1') {
        this.considerarHorarioAtendimento = true
      } else if (query.considerar_horario === '0') {
        this.considerarHorarioAtendimento = false
      }
    },
    async carregarLojas() {
      const contas = await buscaChatsTeste()
      this.facebookAccountsLista = contas.chats || []
      if ((contas.chats || []).length === 1) {
        this.chatSelecionado = contas.chats[0].chat_token
      } else if ((contas.chats || []).length > 1) {
        this.chatSelecionado = (contas.chats[0] && contas.chats[0].chat_token) || null
      } else {
        this.$bvToast.toast('Nenhuma loja encontrada.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },
    async carregarDados() {
      if (!this.chatSelecionado) return
      const inicio = new Date(this.periodoInicio)
      const fim = new Date(this.periodoFim)
      if (inicio > fim) {
        this.$bvToast.toast('A data de início não pode ser maior que a data de fim.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }
      const diffDias = Math.ceil((fim - inicio) / (1000 * 60 * 60 * 24))
      if (diffDias > 31) {
        this.$bvToast.toast('O período não pode exceder 31 dias.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }

      this.carregando = true
      const uuid = this.chatSelecionado
      const inicioISO = inicio.toISOString().split('T')[0]
      const fimISO = fim.toISOString().split('T')[0]

      try {
        const [tags, dadosResolvidos] = await Promise.all([
          buscaTag(uuid),
          buscaResolvidos(uuid, inicioISO, fimISO, 'all'),
        ])
        this.listaTags = Array.isArray(tags) ? tags : []
        this.resolvidos = (dadosResolvidos?.resolvidos || [])
      } catch (err) {
        console.error('Erro ao carregar etiquetas:', err)
        this.$bvToast.toast(err.message || 'Erro ao carregar dados.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
        this.resolvidos = []
      } finally {
        this.carregando = false
      }
    },
  },
}
</script>

<style>
body:has(.etiquetas-page) .content-area-wrapper {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-width: 100% !important;
  width: 100% !important;
}
body:has(.etiquetas-page) .app-content.content {
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 100% !important;
}
body:has(.etiquetas-page) .content-wrapper,
body:has(.etiquetas-page) .content-body {
  padding: 0 !important;
  margin: 0 !important;
  max-width: 100% !important;
}
body:has(.etiquetas-page) .content-right {
  width: 100% !important;
  max-width: 100% !important;
  flex: 1 1 auto !important;
  min-width: 0 !important;
}
</style>

<style scoped>
.etiquetas-page {
  padding: 1rem;
  min-height: 100vh;
  max-width: 100%;
  overflow-x: hidden;
}

.dashboard-header {
  background: linear-gradient(135deg, #9A3092 0%, #c44ab8 100%);
  padding: 1.25rem 1.5rem;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(154, 48, 146, 0.25);
}

.dashboard-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  margin: 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.dashboard-title .titulo-icon-left {
  flex-shrink: 0;
}

.dashboard-title .titulo-texto {
  line-height: 1;
}

.dashboard-header-home {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.95);
  padding: 0.2rem;
  border-radius: 8px;
  transition: background 0.2s, color 0.2s;
  flex-shrink: 0;
}

.dashboard-header-home >>> svg {
  display: block;
  width: 16px;
  height: 16px;
}

.dashboard-header-home:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
}

.dashboard-header .text-muted {
  color: rgba(255, 255, 255, 0.9) !important;
}

.dashboard-header-subtitle {
  margin-top: 0.15rem;
}

.dashboard-header-titulo-row {
  margin-bottom: 0.15rem;
}

.card-selecao-loja .select-loja {
  max-width: 300px;
  min-width: 0;
}

.table-card,
.filtros-card.periodo-card {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.periodo-card .card-body {
  padding: 1rem 1.25rem;
}

.periodo-card-trigger {
  cursor: pointer;
  padding: 0.25rem 0;
  user-select: none;
}

.periodo-trigger-icon {
  flex-shrink: 0;
}

.periodo-trigger-label {
  font-weight: 600;
  color: #5e5873;
}

.periodo-trigger-range {
  font-size: 0.9rem;
}

.periodo-trigger-chevron {
  flex-shrink: 0;
}

.periodo-card-body {
  border-top: 1px solid #ebe9f1;
  padding-top: 1rem;
}

.periodo-presets-title {
  font-weight: 600;
  color: #5e5873;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
}

.periodo-presets-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.periodo-preset-btn {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d8d6de;
  border-radius: 8px;
  background: #fff;
  color: #5e5873;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
}

.periodo-preset-btn:hover {
  background: #f8f9fa;
  border-color: #9A3092;
  color: #9A3092;
}

.periodo-preset-btn.active {
  background: #9A3092;
  border-color: #9A3092;
  color: #fff;
}

.periodo-field-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 500;
  color: #5e5873;
  margin-bottom: 0.35rem;
}

.periodo-datepicker >>> .form-control {
  border-radius: 8px;
  border-color: #d8d6de;
}

.periodo-card-footer {
  flex-wrap: wrap;
}

.card-title-custom {
  font-weight: 600;
  color: #5e5873;
}

.tabela-etiquetas-clickable >>> tbody tr {
  cursor: pointer;
}

.tabela-etiquetas {
  border-radius: 8px;
  overflow: hidden;
}

.badge-etiqueta {
  padding: 0.35em 0.6em;
}
</style>
